import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import CryptoJS from 'crypto-js';
import "./css/Cambiar.css"

const Cambiar = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const ruta = "https://www.ajesl.es:4433";

    useEffect(() => {
        // Captura los parámetros de consulta de la URL
        const queryParams = new URLSearchParams(window.location.search);
        const idParam = queryParams.get('id');

        const fetchUser = async () => {
            try {
                const response = await fetch(ruta + '/cambiar_si_id', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ id: idParam })
                });
                if (response.ok) {
                    const data = await response.json();
                    if (data.length > 0) {
                        const userData = data[0]; // Obtener el primer elemento del array
                        setUser(userData); // Almacenar el objeto en el estado
                    }
                }
            } catch (error) {
                setError('Usuario no encontrado o enlace inválido');
            }
        };

        fetchUser();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const hashedPassword = CryptoJS.SHA256(password).toString();
        try {
            const response = await fetch(ruta + '/actualizar_contrasenia', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email: user.email, password: hashedPassword, username: user.username })
            });
            if (response.ok) {
                const data = await response.json();
                alert(`Recuerde su Usuario es:  \"${user.username}\", el correo es en el que ha recibido el email y la contraseña es la que acaba de introducir, ahora será redirigido a \"/login\"`);
                navigate('/login');
            }
        } catch (error) {
            alert('Error al actualizar la contraseña');
        }
    };

    if (error) {
        return <div>{error}</div>;
    }

    if (!user) {
        return <div>Cargando...</div>;
    }

    return (
        <div className='contenedor_registro'>
            <div className='row justify-content-center'>
                <div className='col-10 text-center'>
                    <div className='titulo_ca col-12 col-md-12 justify-content-center'><p>Hola, {user.username}</p></div>
                    <form className='formulario_login col-12 col-md-12' onSubmit={handleSubmit}>
                        <div className='row col-12 col-md-12'>
                            <label className='etiqueta col-6 col-md-6' htmlFor="password">Nueva Contraseña</label>
                            <input className='casilla col-6 col-md-6'
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            /> 
	                    </div>
                            <div className='row col-12 col-md-12'>
                                <div className='blanco col-6 col-md-6'></div>
                                <button className='boton_login col-6 col-md-6' type="submit">Cambiar Contraseña</button>
                            </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Cambiar;
